export default __webpack_public_path__ + "static/media/edit.50ff8795.svg";